// Module
var code = "<div class=\"force search-wrap\"> <div id=\"mb-object-filter\"></div> </div> <div class=\"mb-obj-list\"> <div class=\"list-data\"> <div class=\"obj-list-data\" id=\"perfectscroll\"> <div id=\"mb-object-result\"></div> </div> </div> </div> ";
// Exports
export default code;